import { gql } from "@urql/core";

export const ConfigUpdateMut = gql`
  mutation editConfiguration($input: EditConfigurationInput!) {
    editConfiguration(input: $input)
  }
`;

export const ConfigCopyMut = gql`
  mutation copyConfiguration($input: CopyConfigurationInput) {
    copyConfiguration(input: $input) {
      id
      quantity
      nodeId
      systemPath
    }
  }
`;

// export const ConfigMoveMut = gql`
//   mutation ($id: String!, $destinationNodeId: String!) {
//     moveProjectNodeConfiguration(
//       id: $id
//       destinationNodeId: $destinationNodeId
//     ) {
//       id
//       quantity
//       nodeId
//       systemPath
//       referencePosition
//     }
//   }
// `;

export const ConfigMoveMut = gql`
  mutation repositionConfiguration($input: RepositionConfigurationInput) {
    repositionConfiguration(input: $input)
  }
`;

export const ConfigDeleteMut = gql`
  mutation deleteConfiguration($input: DeleteConfigurationInput) {
    deleteConfiguration(input: $input) {
      id
      nodeId
      systemPath
    }
  }
`;
